/* Moulin de l'Aunay — logique des offres (chargé une fois via theme.liquid).
 * Deux responsabilités, une seule source de vérité (/cart.js) :
 *   1) CODE AVANTAGE — appliquer / retirer / remplacer un code + indication « code actif ».
 *      Markup : snippets/ma-code-avantage.liquid + ma-code-avantage-bandeau.liquid.
 *   2) FILTRE CADEAU — n'afficher, dans le picker du panier, que les 4 cadeaux de
 *      l'opération du code actif. Markup : snippets/cart-gift-picker.liquid.
 * Tout le comportement vit ICI (délégation d'événements) pour survivre au ré-rendu du
 * panier/drawer par le section-rendering de Shopify, où les <script> inline ne tournent pas. */
(function () {
  'use strict';

  // Opération = 2e lettre du code (F=R6, G=R7, H=R8, I=R9, J=R10, K=R11).
  // Valeurs = SKU/réf des 4 cadeaux de l'opération. PATA est partagé par R6/R7/R9 ;
  // MACNB par R6/R9. >>> À COMPLÉTER À CHAQUE NOUVELLE OPÉRATION (nouvelle lettre). <<<
  var GIFT_MAP = {
    F: ['SERV', 'MACNB', 'FENO', 'PATA'],
    G: ['SACISO', 'DIGES', 'GUGC66', 'PATA'],
    H: ['JUM', 'SLIM', 'MAVE', 'PATN'],
    I: ['SWARO', 'MACNB', 'N589', 'PATA'],
    J: ['NAPPE', 'G140', 'FENO', 'LAX'],
    K: ['WEEK', 'DUO', 'GIN66', 'PATA']
  };

  // Opérations DÉDIÉES à un produit : leur code ne suit pas le format historique, donc la
  // 2e lettre ne désigne aucune opération -> on les indexe par le CODE ENTIER. Consulté
  // AVANT GIFT_MAP, ce qui évite aussi qu'une future opération de la série R (lettre E…)
  // hérite par accident des cadeaux d'un code dédié.
  // DETOX35 = opération Eau de Colon (−35 % sur les prix de lots de la réf DETNAT).
  // RB26 = catalogue papier RB-26. Offre « lots + cadeau » standard (même remise Shopify
  // que QIP05/LIP10) : seul son NOM sort du format, d'où son passage par ces deux tables.
  var GIFT_MAP_BY_CODE = {
    DETOX35: ['SACISO', 'DIGES', 'FENO', 'SLIM'],
    RB26: ['JUM', 'PATN', 'PATA', 'SACISO']
  };

  // Code actif (MAJUSCULES). Source de vérité = /cart.js ; repli = mémoire locale.
  var currentCode = '';

  var UPDATE_URL = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';

  // Offre Type 2 (prix unique 5 €) : code d'OPÉRATION dont le suffixe numérique est >= 50
  // (ex. QFP75, QGP50, QHP95). Type 1 (lots) = suffixe < 50 (ex. QFP05) -> pas de plafond.
  // Le test de FORMAT est indispensable : type 2 = exclusif (applyCode vide le panier de ses
  // autres codes). Sans lui, un code NATIF finissant par >= 50 (ex. SOLDES50) serait pris pour
  // une offre 2 et supprimerait silencieusement l'opération en cours.
  var MAX_TYPE2 = 5; // unités max par référence pour l'offre à 5 €

  // Réfs EXCLUES de l'offre à 5 € : facturées au prix de lot habituel par la Function
  // « prix unique + cadeau », donc le plafond de 5 unités ne les concerne pas — ce serait
  // refuser une vente sur un produit qui n'est pas en promotion.
  // SOURCE DE VÉRITÉ DU PRIX = la balise Shopify `hors-offre-5e` posée sur la fiche produit
  // (lue par la Function). Cette liste-ci ne pilote QUE le plafond de quantité côté panier :
  // Liquid ne donne pas accès aux balises depuis /cart.js. À tenir à jour avec les balises.
  var NO_UNIT_PRICE_SKUS = ['SUED']; // Élixir du Suédois — décision client 2026-08-06
  // Mêmes produits, désignés par leur handle : c'est la seule prise qu'on ait sur une
  // ligne de PANIER, dont le DOM ne porte pas le SKU (il porte un lien /products/<handle>).
  var NO_UNIT_PRICE_HANDLES = ['sued'];

  function isExcludedFromType2(it) {
    var sku = (it && it.sku ? String(it.sku) : '').trim().toUpperCase();
    return !!sku && NO_UNIT_PRICE_SKUS.indexOf(sku) !== -1;
  }

  // Le sélecteur de quantité `el` porte-t-il sur un produit exclu ?
  // - Panier : on remonte à la ligne et on lit le handle du lien produit.
  // - Fiche produit : pas de ligne parente -> on lit le data-sku du bloc « cartes de lots ».
  function qtySelectorIsExcluded(el) {
    var row = el.closest('[data-line-index], .cart-item, li');
    if (row) {
      var link = row.querySelector('a[href*="/products/"]');
      if (link) {
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        return !!m && NO_UNIT_PRICE_HANDLES.indexOf(m[1].toLowerCase()) !== -1;
      }
    }
    var box = document.querySelector('[data-sku]');
    var sku = box ? (box.getAttribute('data-sku') || '').trim().toUpperCase() : '';
    return !!sku && NO_UNIT_PRICE_SKUS.indexOf(sku) !== -1;
  }

  function isType2(code) {
    var up = (code || '').toUpperCase();
    if (!isValidCodeFormat(up)) return false; // un code natif n'est jamais une offre 2
    // Les codes dédiés sont des offres de type 1 (grille de lots) : leur suffixe est un
    // argument commercial (« −35 % »), pas le suffixe numérique du format d'opération.
    // Sans ce garde-fou, un futur code dédié en 50+ (ex. PROMO60) serait pris pour une
    // offre à 5 €, deviendrait exclusif et plafonnerait les quantités à 5.
    if (SPECIAL_CODES.indexOf(up) !== -1) return false;
    // Opérations sans offre à 5 € : tous leurs codes sont des lots, même en suffixe >= 50.
    if (['J', 'K'].indexOf(up.charAt(1)) !== -1) return false;
    return parseInt(up.slice(-2), 10) >= 50;  // format garanti -> 2 derniers caractères = chiffres
  }

  // Format d'un code avantage MA : 2 lettres (préfixe Q/L + lettre d'opération) + P + 2 chiffres,
  // ex. QFP05, LGP10, QHP75. Seul garde-fou fiable contre les saisies quelconques : Shopify
  // enregistre et renvoie n'importe quel code inconnu (applicable:false), donc sa réponse ne
  // permet pas de distinguer une faute de frappe d'un vrai code Function pas encore applicable.
  // Codes d'opération DÉDIÉS à un produit, hors format historique (le nom porte l'offre :
  // DETOX35 = Eau de Colon à −35 %). Ils sont pilotés par une Discount Function au même
  // titre que les codes d'opération, donc ils doivent recevoir le MÊME traitement :
  // acceptation optimiste (Shopify ne renvoie pas `applicable:true` de façon fiable pour
  // une remise Function -> traités en « natif », ils seraient refusés à tort), révélation
  // des cartes de lots, et contrôle par la liste blanche. Toute entrée ajoutée ici doit
  // donc AUSSI figurer dans docs/Codes Operation MA.csv (sinon le code est rejeté).
  var SPECIAL_CODES = ['DETOX', 'DETOX35', 'RB26'];

  // Codes dont la remise Shopify REFUSE les remises de commande (« Combinaisons » →
  // « réductions de commande » décoché). Ils bloquent donc un code natif comme BIENVENUE10,
  // et doivent être nommés dans le message d'erreur plutôt que de laisser croire à une
  // faute de frappe. Les offres de TYPE 2 sont détectées automatiquement (isType2) ; cette
  // liste ne sert qu'aux codes hors format, dont le réglage ne se déduit pas du nom.
  //
  // ⚠️ À TENIR À JOUR AVEC L'ADMIN : c'est une recopie d'un réglage Shopify que le thème ne
  // peut pas lire. DETOX35 y est entré le 2026-08-18, quand le cumul avec les remises de
  // commande a été retiré côté admin. DETOX y est entré le 2026-08-31, créé d'emblée sans
  // cumul de commande (combinesWith.orderDiscounts = false). Si le cumul était rouvert, retirer le code d'ici —
  // sinon le site accuserait une offre qui ne bloque plus rien.
  var NO_ORDER_CUMUL_CODES = ['DETOX', 'DETOX35'];

  // EMPREINTE d'un code (2026-09-30) : les codes des annonces presse ne sont pas écrits en
  // clair dans ce fichier, servi publiquement (/cdn/shop/t/<n>/assets/ma-offres.js). Les
  // tables presse ci-dessous sont indexées par maFp(code).
  // Calculer une empreinte : node ma-discount-app/scripts/fp.mjs MONCODE.
  // ⚠️ maFp() doit rester IDENTIQUE à scripts/fp.mjs et au test des extensions presse-*.
  function maFp(code) {
    var s = 'MA-fp-v1:' + String(code || '').toUpperCase();
    var h1 = 0x811c9dc5, h2 = 0x01000193;
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      h1 = Math.imul((h1 ^ c) >>> 0, 0x01000193) >>> 0;
      h2 = Math.imul((h2 + c) >>> 0, 0x85ebca6b) >>> 0;
      h2 = (h2 ^ (h2 >>> 13)) >>> 0;
    }
    return ('0000000' + h1.toString(16)).slice(-8) + ('0000000' + h2.toString(16)).slice(-8);
  }

  // Plafond de MAX_TYPE2 unités par référence : offre à 5 € ET offre lecteurs (presse).
  function hasUnitCap(code) { return isType2(code) || !!presseOf(code); }

  function isValidCodeFormat(code) {
    var up = (code || '').toUpperCase();
    if (SPECIAL_CODES.indexOf(up) !== -1) return true;
    if (presseOf(up)) return true; // offre lecteurs : codes dédiés, indexés par empreinte
    return /^[QL][A-Z]P\d{2}$/.test(up);
  }
  // Sel partagé avec ma-discount-app/scripts/gen-whitelist.mjs (const SALT) — DOIT être
  // identique des deux côtés, sinon les empreintes ne correspondent plus (tous les codes
  // seraient rejetés).
  var MA_CODE_SALT = 'MA-codes-v1:';
  function sha256Hex(str) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      var a = new Uint8Array(buf), h = '';
      for (var i = 0; i < a.length; i++) h += a[i].toString(16).padStart(2, '0');
      return h;
    });
  }
  // LISTE BLANCHE (assets/ma-codes.js -> window.MA_ACTIVE_CODES) : EMPREINTES SHA-256 des codes
  // actifs — jamais les codes en clair, donc le site n'expose aucun code. Un code au format
  // opération n'est « connu » que si l'empreinte de (SALT+code) figure dans la liste.
  // Renvoie une PROMISE<bool>. Replis SÛRS -> permissif (on ne bloque jamais tout le monde) :
  //  - liste absente/vide (asset non chargé) : on retombe sur le format seul ;
  //  - crypto.subtle indisponible (contexte non sécurisé) : on accepte.
  // Ne concerne PAS les codes natifs (hors format, validés par Shopify).
  function isKnownOpCode(code) {
    var up = (code || '').toUpperCase();
    var list = window.MA_ACTIVE_CODES;
    if (!Array.isArray(list) || !list.length) return Promise.resolve(isValidCodeFormat(up));
    if (!isValidCodeFormat(up)) return Promise.resolve(false);
    if (!(window.crypto && crypto.subtle)) return Promise.resolve(true);
    return sha256Hex(MA_CODE_SALT + up).then(function (h) { return list.indexOf(h) !== -1; });
  }
  function isGiftItem(it) {
    return !!(it && it.properties && String(it.properties._gift).toLowerCase() === 'true');
  }

  // ---------------------------------------------------------------------------
  // Mémoire locale (partagée avec le bloc « cartes de lots » : clés ma_code_active / ma_code_value)
  // ---------------------------------------------------------------------------
  function fromLocal() {
    try { return (localStorage.getItem('ma_code_value') || '').toUpperCase(); } catch (e) { return ''; }
  }
  function storeCode(code) {
    try { localStorage.setItem('ma_code_active', '1'); localStorage.setItem('ma_code_value', code); } catch (e) {}
  }
  function forgetCode() {
    try { localStorage.removeItem('ma_code_active'); localStorage.removeItem('ma_code_value'); } catch (e) {}
  }
  function fromDom() {
    var el = document.querySelector('[data-ma-gift][data-active-code]');
    var c = el && el.getAttribute('data-active-code');
    return c ? c.toUpperCase() : '';
  }

  // ---------------------------------------------------------------------------
  // FILTRE CADEAU
  // ---------------------------------------------------------------------------
  function applyGiftFilter() {
    var pickers = document.querySelectorAll('.cart-gift');
    if (!pickers.length) return; // picker absent -> rien à faire (appel bon marché)
    // Cadeaux autorisés pour le code d'OPÉRATION actif (un code natif comme BIENVENUE10 ne
    // devient jamais currentCode). Deux indexations, dans cet ordre :
    //  1. code ENTIER, pour les opérations dédiées à un produit (ex. DETOX35) ;
    //  2. 2e lettre du code, pour la série historique au format ^[QL][A-Z]P\d{2}$ (F=R6…).
    var code = (currentCode || '').toUpperCase();
    var allow = GIFT_MAP_BY_CODE[code] || GIFT_MAP[code.charAt(1)] || null; // sinon AUCUN cadeau
    // Offre lecteurs : cadeau unique ajouté automatiquement (ensurePresseGift) -> rien à
    // choisir, et le seuil de 45 € du sélecteur ne la concerne pas.
    if (presseOf(code)) {
      pickers.forEach(function (box) { box.style.display = 'none'; });
      return;
    }
    pickers.forEach(function (box) {
      var ul = box.querySelector('.cart-gift__list');
      if (!ul) return; // hint / progression / cadeau déjà choisi -> pas de sélection à filtrer
      if (!allow) {
        // Aucun code d'opération (panier nu ou code natif seul) : on masque toute la
        // sélection — pas d'offre cadeau sans code avantage. Inline pour battre `:has()`.
        box.style.display = 'none';
        return;
      }
      box.style.display = '';
      ul.querySelectorAll('[data-gift-sku]').forEach(function (li) {
        var sku = (li.getAttribute('data-gift-sku') || '').toUpperCase();
        li.hidden = allow.indexOf(sku) === -1;
      });
    });
  }

  // PLAFOND 5 UNITÉS (offre Type 2) — bloque visuellement le compteur : max=5 sur
  // l'input et bouton « + » désactivé à 5. S'applique aux sélecteurs de quantité
  // (fiche produit ET panier). Réappliqué au ré-rendu via l'observer/les événements.
  function applyQtyCap() {
    var type2 = hasUnitCap(currentCode);
    document.querySelectorAll('.quantity-selector').forEach(function (comp) {
      var input = comp.querySelector('input[type="number"]');
      if (!input) return;
      var plus = comp.querySelector('button[name="plus"]');
      if (type2 && !qtySelectorIsExcluded(comp)) {
        input.setAttribute('max', String(MAX_TYPE2));
        input.dataset.maCap = '1';
        if (plus) plus.disabled = (parseInt(input.value, 10) || 0) >= MAX_TYPE2;
      } else if (input.dataset.maCap) {
        input.removeAttribute('max');
        delete input.dataset.maCap;
        if (plus) plus.disabled = false;
      }
    });
  }

  // Filet de sécurité : si une ligne payante dépasse 5 unités alors qu'un code Type 2
  // est actif, on ramène sa quantité à 5 (peu importe comment on y est arrivé).
  // Les réfs de NO_UNIT_PRICE_SKUS en sont dispensées : elles restent au prix de lot,
  // donc rien ne justifie de limiter la quantité commandée.
  // Renvoie true si un ajustement a été déclenché (un cart:update suivra).
  function clampType2(cart) {
    if (!hasUnitCap(currentCode) || !cart || !cart.items || !cart.items.length) return false;
    var changed = false;
    var updates = cart.items.map(function (it) {
      if (!isGiftItem(it) && !isExcludedFromType2(it) && it.quantity > MAX_TYPE2) {
        changed = true;
        return MAX_TYPE2;
      }
      return it.quantity;
    });
    if (!changed) return false;
    fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        maNotice((isType2(currentCode) ? 'Offre à 5 € : ' : 'Cette offre : ') + '5 unités maximum par référence — les quantités ont été ajustées.');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
      })
      .catch(function () {});
    return true;
  }

  // Petit bandeau d'information éphémère (bas de page).
  var noticeEl = null, noticeTimer = null;
  function maNotice(text) {
    if (!noticeEl) {
      noticeEl = document.createElement('div');
      noticeEl.className = 'ma-notice';
      noticeEl.setAttribute('role', 'status');
      document.body.appendChild(noticeEl);
    }
    noticeEl.textContent = text;
    noticeEl.classList.add('is-visible');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { noticeEl.classList.remove('is-visible'); }, 4500);
  }


  // ---------------------------------------------------------------------------
  // OFFRE LECTEURS (annonces presse, 2026-09-30) — docs/OPERATION-PRESSE-*.md
  // ---------------------------------------------------------------------------
  // Grille 1 / 2 / 3 flacons sur 8 références, cadeau unique offert sans seuil, port
  // offert au-delà d'un seuil (ce dernier géré par la Function seule).
  // Le PRIX FACTURÉ vient des Functions presse-* (ma-discount-app) ; cette table ne sert
  // qu'à l'AFFICHAGE. Elle doit rester identique à extensions/presse-*/src/presse-offres.ts :
  // le test « grille du thème » de ces extensions relit le bloc JSON ci-dessous.
  // Indexé par empreinte du code (maFp), comme les autres tables de ce fichier.
  var PRESSE_OFFERS = /*PRESSE-JSON*/{
    "f8a6fe703a1cba46": {"gift": "ZEN", "grid": {
      "ARTI4": [8, 15, 22], "DETNAT": [9, 17, 24], "KITO": [7, 13, 19], "N580": [8, 15, 22],
      "PROS66": [8, 15, 22], "CURC1": [7, 13, 19], "SER66": [7, 13, 19], "SXC10": [9, 17, 24]}},
    "4063ec037eddc19f": {"gift": "ZEN", "grid": {
      "ARTI4": [9, 17, 24], "DETNAT": [10, 19, 27], "KITO": [8, 15, 22], "N580": [9, 17, 24],
      "PROS66": [9, 17, 24], "CURC1": [10, 19, 27], "SER66": [9, 17, 24], "SXC10": [12, 23, 32]}}
  }/*/PRESSE-JSON*/;
  function presseOf(code) { return code ? PRESSE_OFFERS[maFp(code)] || null : null; }

  function euro(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  // Styles des cartes : injectés ici, car la fiche Eau de Colon ne charge pas ceux des
  // cartes de lots (bloc Custom Liquid des templates produit).
  function presseCss() {
    if (document.getElementById('ma-presse-css')) return;
    var st = document.createElement('style');
    st.id = 'ma-presse-css';
    st.textContent =
      '.ma-presse{margin:1rem 0}' +
      '.ma-presse__title{margin:0 0 .5rem;font-weight:600;color:#1f2d3d}' +
      '.ma-presse__tag{display:inline-block;margin-left:.35rem;background:#c0392b;color:#fff;font-size:.75rem;font-weight:700;padding:.1rem .45rem;border-radius:10px;vertical-align:middle}' +
      '.ma-presse__grid{display:flex;gap:.6rem;flex-wrap:wrap;align-items:stretch}' +
      '.ma-presse__card{position:relative;flex:1 1 7rem;min-width:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.15rem;padding:1rem .6rem;border:1px solid #cdd7e2;border-radius:14px;background:#fff;cursor:pointer;font-family:inherit}' +
      '.ma-presse__card:hover{border-color:#27ae60;box-shadow:0 0 0 2px rgba(39,174,96,.15)}' +
      '.ma-presse__card--best{border-color:#27ae60}' +
      '.ma-presse__card[disabled]{opacity:.6;cursor:default}' +
      '.ma-presse__badge{position:absolute;top:-.6rem;background:#27ae60;color:#fff;font-size:.7rem;font-weight:600;padding:.1rem .5rem;border-radius:10px;white-space:nowrap}' +
      '.ma-presse__name{font-size:.95rem;font-weight:600;color:#1f2d3d}' +
      '.ma-presse__old{font-size:.85rem;color:#8a97a5;text-decoration:line-through}' +
      '.ma-presse__price{font-size:1.15rem;font-weight:700;color:#1e8449}' +
      '.ma-presse__note{margin:.5rem 0 0;font-size:.85rem;color:#5a6b7b}';
    document.head.appendChild(st);
  }

  // Remplit `host` : cartes presse si la réf est dans la grille, sinon simple mention
  // « prix habituel » (la Function ne remise PAS les autres produits sous ce code : les
  // cartes de lots habituelles annonceraient des prix que le panier ne ferait pas).
  // `unit` = prix normal d'un flacon en euros (0 si inconnu : pas de prix barré).
  function renderPresse(host, offer, sku, variantId, unit) {
    presseCss();
    var g = offer.grid[sku];
    var html = '<div class="ma-presse" data-ma-presse-fp="' + maFp(currentCode) + '">';
    if (!g) {
      html += '<p class="ma-presse__note">Ce produit n\'est pas concerné par l\'offre lecteurs : il reste à son prix habituel.</p>';
    } else {
      html += '<p class="ma-presse__title">Offre lecteurs<span class="ma-presse__tag">prix réservés</span></p><div class="ma-presse__grid">';
      for (var q = 1; q <= 3; q++) {
        html += '<button type="button" class="ma-presse__card' + (q === 3 ? ' ma-presse__card--best' : '') + '" data-presse-qty="' + q + '" data-variant-id="' + variantId + '">'
          + (q === 3 ? '<span class="ma-presse__badge">le + avantageux</span>' : '')
          + '<span class="ma-presse__name">' + q + ' flacon' + (q > 1 ? 's' : '') + '</span>'
          + (unit * q > g[q - 1] ? '<span class="ma-presse__old">' + euro(unit * q) + '</span>' : '')
          + '<span class="ma-presse__price">' + euro(g[q - 1]) + '</span>'
          + '</button>';
      }
      html += '</div><p class="ma-presse__note">5 flacons maximum par produit.</p>';
    }
    host.innerHTML = html + '</div>';
  }

  // Applique (ou retire) l'affichage presse sur la fiche produit. Appelé par
  // applyDomRules(), donc aussi après chaque mutation du DOM : le bloc des cartes de lots
  // se reconstruit sur cart:update, on repasse alors derrière lui. Idempotent (marqueur
  // data-ma-presse-fp), sinon l'observer tournerait en boucle.
  var presseShown = false;
  var edcUnit = null; // prix normal d'un flacon d'Eau de Colon (€), chargé à la demande
  function applyPresseCards() {
    var offer = presseOf(currentCode);
    var fp = offer ? maFp(currentCode) : '';

    // Cartes de lots habituelles (tous produits sauf Eau de Colon).
    if (offer) {
      document.querySelectorAll('[data-ma-lots]').forEach(function (box) {
        if (box.querySelector('[data-ma-presse-fp="' + fp + '"]')) return;
        var full = (window.MA_LOT_PRICES || {})[box.dataset.sku];
        renderPresse(box, offer, box.dataset.sku, box.dataset.variantId, full ? full.unit : 0);
      });
    }

    // Eau de Colon (sections/eau-de-colon-v2-product.liquid) : seul le SÉLECTEUR de cure
    // 3 / 6 / 9 est masqué — cartes des cures, bouton « Ajouter au panier » et sous-titre.
    // Les cartes presse prennent sa place ; titre « Choisissez votre cure » (ancre #offre),
    // réassurance, paiement et reste de la page restent visibles.
    // Prix normal d'un flacon : lu dans /products/<handle>.js (la section ne l'expose pas).
    var EDC2_SELECTOR = '[data-edc2-bundles], [data-edc2-add-to-cart], .edc2-offer-head p';
    document.querySelectorAll('[data-edc2-root]').forEach(function (root) {
      var host = root.querySelector('[data-ma-presse-host]');
      if (!offer) {
        root.querySelectorAll('[data-ma-presse-hidden]').forEach(function (el) {
          el.style.display = '';
          el.removeAttribute('data-ma-presse-hidden');
        });
        if (host) host.remove();
        return;
      }
      root.querySelectorAll(EDC2_SELECTOR).forEach(function (el) {
        if (el.hasAttribute('data-ma-presse-hidden')) return;
        el.style.display = 'none';
        el.setAttribute('data-ma-presse-hidden', '');
      });
      var bundles = root.querySelector('[data-edc2-bundles]');
      if (!bundles) return;
      if (!host) {
        host = document.createElement('div');
        host.setAttribute('data-ma-presse-host', '');
        bundles.parentNode.insertBefore(host, bundles);
      }
      if (host.querySelector('[data-ma-presse-fp="' + fp + '"]')) return;
      renderPresse(host, offer, 'DETNAT', root.dataset.variantId, edcUnit || 0);
      if (edcUnit === null) {
        edcUnit = 0; // une seule requête
        fetch(location.pathname.replace(/\/$/, '') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            edcUnit = ((p && p.price) || 0) / 100;
            if (edcUnit && host.isConnected) renderPresse(host, offer, 'DETNAT', root.dataset.variantId, edcUnit);
          })
          .catch(function () {});
      }
    });

    applyPressePrices(offer, fp);

    // Sortie de l'offre : le bloc des cartes de lots redessine ses cartes habituelles.
    if (presseShown && !offer) document.dispatchEvent(new CustomEvent('ma:code-applied', { bubbles: true }));
    presseShown = !!offer;
  }

  // PRIX DES VIGNETTES produit (collection offre-lecteurs, accueil, recherche…) : sous un
  // code presse, le prix affiché devient celui d'1 flacon au tarif presse, prix normal barré.
  // Les vignettes Horizon (<product-price data-product-id>) ne portent pas le SKU : la
  // correspondance id produit -> SKU est lue une fois dans la collection de l'offre.
  // Le contenu d'origine est gardé pour être rendu à la sortie de l'offre.
  var PRESSE_COLLECTION = '/collections/offre-lecteurs/products.json?limit=250';
  var presseSkuById = null; // null = pas encore chargé ; {} pendant/après le chargement
  function applyPressePrices(offer, fp) {
    var prices = document.querySelectorAll('product-price[data-product-id]');
    if (!prices.length) return;
    if (!offer) {
      prices.forEach(function (el) {
        var box = el.querySelector('[ref="priceContainer"]') || el;
        if (box.hasAttribute('data-ma-presse-orig')) {
          box.innerHTML = box.getAttribute('data-ma-presse-orig');
          box.removeAttribute('data-ma-presse-orig');
          box.removeAttribute('data-ma-presse-fp');
        }
      });
      return;
    }
    if (presseSkuById === null) {
      presseSkuById = {};
      fetch(PRESSE_COLLECTION, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          ((data && data.products) || []).forEach(function (p) {
            var v = (p.variants || [])[0];
            if (v && v.sku) presseSkuById[String(p.id)] = { sku: String(v.sku).trim().toUpperCase(), unit: Number(v.price) || 0 };
          });
          scheduleFilter();
        })
        .catch(function () { presseSkuById = null; });
      return;
    }
    prices.forEach(function (el) {
      var info = presseSkuById[el.getAttribute('data-product-id')];
      var g = info && offer.grid[info.sku];
      if (!g) return;
      var box = el.querySelector('[ref="priceContainer"]') || el;
      if (box.getAttribute('data-ma-presse-fp') === fp) return; // déjà fait (observer)
      if (!box.hasAttribute('data-ma-presse-orig')) box.setAttribute('data-ma-presse-orig', box.innerHTML);
      box.setAttribute('data-ma-presse-fp', fp);
      box.innerHTML = '<span class="price">' + euro(g[0]) + '</span>'
        + (info.unit > g[0] ? ' <s class="ma-presse__old" style="font-weight:400;font-size:.85em;color:#8a97a5">' + euro(info.unit) + '</s>' : '');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-presse-qty]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: Number(btn.getAttribute('data-presse-qty')) }] })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
      })
      .catch(function () { btn.disabled = false; maNotice('Ajout impossible pour le moment.'); });
  });

  // CADEAU AUTOMATIQUE : un seul cadeau possible, offert sans seuil -> rien à choisir,
  // on l'ajoute dès qu'il y a un article payant. Retiré par le filet de sécurité de
  // layout/theme.liquid si le panier ne contient plus que lui (il n'est plus à 0 €).
  // L'ID de variante se lit dans la collection publique des cadeaux (SKU -> variante).
  var giftIds = null, giftBusy = false, giftFailed = {};
  function giftVariantId(sku) {
    if (!giftIds) {
      giftIds = fetch('/collections/cadeaux-offerts/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var map = {};
          ((data && data.products) || []).forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              if (v.sku && v.available !== false) map[String(v.sku).trim().toUpperCase()] = v.id;
            });
          });
          return map;
        })
        .catch(function () { giftIds = null; return {}; });
    }
    return giftIds.then(function (map) { return map[sku] || null; });
  }

  // Renvoie true si un ajout est lancé (un cart:update suivra).
  function ensurePresseGift(cart) {
    var offer = presseOf(currentCode);
    if (!offer || giftBusy || giftFailed[offer.gift] || !cart || !cart.items) return false;
    var paid = cart.items.some(function (it) { return !isGiftItem(it); });
    var gifts = cart.items.filter(function (it) {
      return isGiftItem(it) && String(it.sku || '').trim().toUpperCase() === offer.gift;
    });
    // Un seul cadeau : la Function n'en offre qu'un, mais un cadeau vendu 0 € (CADS)
    // resterait gratuit en toute quantité -> on ramène la ligne à 1.
    if (gifts.length && gifts[0].quantity > 1) {
      giftBusy = true;
      var upd = {};
      upd[gifts[0].key] = 1;
      fetch(UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: upd, sections: [] })
      })
        .then(function () {
          giftBusy = false;
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        })
        .catch(function () { giftBusy = false; });
      return true;
    }
    if (!paid || gifts.length) return false;
    giftBusy = true;
    giftVariantId(offer.gift)
      .then(function (id) {
        if (!id) throw 0;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _gift: 'true' } }] })
        }).then(function (r) { if (!r.ok) throw 0; });
      })
      .then(function () {
        giftBusy = false;
        if (window.maSilentCartUpdate) window.maSilentCartUpdate();
        else document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
      })
      .catch(function () { giftBusy = false; giftFailed[offer.gift] = true; }); // rupture, SKU absent : on n'insiste pas
    return true;
  }

  function applyDomRules() { applyGiftFilter(); applyQtyCap(); applyPresseCards(); }

  var raf = null;
  function scheduleFilter() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; applyDomRules(); });
  }

  // ---------------------------------------------------------------------------
  // UI « code avantage » (fiche + bandeau, tous les [data-ma-code] de la page)
  // ---------------------------------------------------------------------------
  // Liste des codes à AFFICHER comme actifs : le code d'OPÉRATION (currentCode, qui pilote
  // seul les cadeaux / le plafond / le type) suivi des codes NATIFS que Shopify confirme
  // `applicable:true` dans le panier (ex. BIENVENUE10). Les natifs ne sont jamais optimistes :
  // ils n'apparaissent que si le serveur les valide.
  function displayList(cart) {
    var out = [], seen = {};
    if (currentCode) { out.push(currentCode); seen[currentCode] = 1; }
    (((cart && cart.discount_codes) || [])).forEach(function (d) {
      var c = (d.code || '').toUpperCase();
      if (!c || seen[c] || isValidCodeFormat(c)) return; // opération déjà gérée via currentCode
      if (d.applicable) { out.push(c); seen[c] = 1; }
    });
    return out;
  }

  // Construit une pastille « ✓ CODE ✕ » (en DOM, pas d'innerHTML -> aucune injection possible).
  // Le ✕ porte son propre code (data-code) : la délégation d'événements retire CE code précis.
  function makeChip(box, code) {
    var isBar = box.hasAttribute('data-ma-codebar');
    var chip = document.createElement('span');
    chip.className = isBar ? 'ma-codebar__chip' : 'ma-code__chip';
    if (isBar) {
      var chk = document.createElement('span');
      chk.className = 'ma-codebar__chip-check';
      chk.setAttribute('aria-hidden', 'true');
      chk.textContent = '✓';
      chip.appendChild(chk);
    }
    var strong = document.createElement('strong');
    strong.textContent = code;
    chip.appendChild(strong);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = isBar ? 'ma-codebar__remove' : 'ma-code__remove';
    btn.setAttribute('data-ma-code-remove', '');
    btn.setAttribute('data-code', code);
    btn.setAttribute('aria-label', 'Retirer le code ' + code);
    btn.setAttribute('title', 'Retirer ' + code);
    btn.textContent = '✕';
    chip.appendChild(btn);
    return chip;
  }

  // `codes` = tableau des codes à afficher (peut être vide). Chaque code = une pastille avec
  // son propre ✕ ; la note « 5 max/réf » suit l'offre à 5 € (pilotée par l'opération active).
  function updateCodeBlocks(codes) {
    var list = codes || [];
    var has = list.length > 0;
    document.querySelectorAll('[data-ma-code]').forEach(function (box) {
      var status = box.querySelector('[data-ma-code-status]');
      var listEl = box.querySelector('[data-ma-code-list]');
      var errEl = box.querySelector('[data-ma-code-err]');
      var note = box.querySelector('[data-ma-code-note]');
      if (listEl) {
        listEl.textContent = ''; // reset
        if (has) list.forEach(function (c) { listEl.appendChild(makeChip(box, c)); });
      }
      if (has) {
        if (status) status.hidden = false;
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        if (note) note.hidden = !hasUnitCap(currentCode); // rappel « 5 max/réf » (offre à 5 €, presse)
        box.classList.add('is-active');
      } else {
        if (status) status.hidden = true;
        if (note) note.hidden = true;
        box.classList.remove('is-active');
      }
    });
  }

  function showError(box, message) {
    var errEl = box && box.querySelector('[data-ma-code-err]');
    if (!errEl) return;
    errEl.textContent = message;
    errEl.hidden = false;
  }

  // ---------------------------------------------------------------------------
  // Lecture de l'état réel : une seule requête /cart.js -> code actif + filtre.
  // ---------------------------------------------------------------------------
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // CODE D'OPÉRATION (pilote cadeaux/plafond/type) = 1er code présent au format opération.
        // Présence suffit (ne PAS filtrer sur `applicable` : une remise Function peut être
        // valide sans encore réduire le panier).
        var op = (((cart && cart.discount_codes) || [])
          .map(function (d) { return (d.code || '').toUpperCase(); })
          .filter(function (c) { return isValidCodeFormat(c); }))[0];
        if (op) {
          currentCode = op;
          storeCode(currentCode);
        } else if (cart && cart.item_count > 0) {
          // Panier non vide sans code d'opération -> plus d'opération active.
          currentCode = '';
          forgetCode();
        } else {
          // Panier vide : Shopify ne conserve pas le code -> on se fie à la mémoire locale.
          currentCode = fromLocal();
        }
        // Nettoyage : une saisie invalide restée en mémoire (ancien bug) ne doit pas
        // réapparaître comme opération active.
        if (currentCode && !isValidCodeFormat(currentCode)) { currentCode = ''; forgetCode(); }
        updateCodeBlocks(displayList(cart)); // opération + codes natifs applicables
        if (clampType2(cart)) return; // un ajustement relancera refresh via cart:update
        if (ensurePresseGift(cart)) return; // idem après l'ajout du cadeau
        applyDomRules();
      })
      .catch(function () {
        currentCode = fromLocal() || fromDom();
        if (currentCode && !isValidCodeFormat(currentCode)) { currentCode = ''; forgetCode(); }
        updateCodeBlocks(currentCode ? [currentCode] : []); // hors ligne : opération seule
        applyDomRules();
      });
  }

  // ---------------------------------------------------------------------------
  // Appliquer un code (remplace l'actuel) — depuis la fiche ou le bandeau.
  // ---------------------------------------------------------------------------
  function applyCode(rawCode, box) {
    var code = (rawCode || '').trim();
    if (!code) return;
    var up = code.toUpperCase();

    // `box` peut être absente : l'auto-application depuis l'URL (?ma_code=) intervient
    // aussi sur des pages qui n'affichent pas le bloc « Code avantage ».
    var form = box && box.querySelector('[data-ma-code-form]');
    var input = form && form.querySelector('[name="ma_code"]');
    var btn = form && form.querySelector('button[type="submit"]');

    // Vérif LISTE BLANCHE (asynchrone : hachage SHA-256). Un code au FORMAT opération n'est
    // accepté que si son empreinte figure dans window.MA_ACTIVE_CODES ; sinon refus local
    // immédiat (expiré/inexistant), sans interroger Shopify. Les codes NATIFS (ex. BIENVENUE10)
    // ne matchent pas le format -> ils sautent la vérif et sont validés à la réponse Shopify.
    (isValidCodeFormat(up) ? isKnownOpCode(up) : Promise.resolve(true)).then(function (known) {
      if (!known) {
        showError(box, 'Code invalide ou périmé. Vérifiez la saisie.');
        if (input) { input.value = ''; input.focus(); }
        return;
      }
      proceed();
    });

    function proceed() {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    function done() { if (btn) { btn.disabled = false; btn.textContent = label; } }

    // CUMUL : on lit d'abord le panier pour conserver les codes PONCTUELS déjà
    // présents (ex. BIENVENUE10, remise d'ordre) et remplacer tout code d'OPÉRATION
    // précédent (un seul code d'opération à la fois). Offre 2 (prix unique 5 €) =
    // exclusive : on repart de zéro. Le cumul effectif dépend aussi des réglages
    // « Combinaisons » Shopify (offre 1 = combinesWith.orderDiscounts:true, cf. app).
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        var existing = (((cart && cart.discount_codes) || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; }));
        var keep;
        if (isType2(up)) {
          keep = [];                                                    // Offre 2 : exclusive
        } else if (isValidCodeFormat(up)) {
          // Offre 1 (opération) : remplacer l'ancienne opération, garder les codes natifs.
          keep = existing.filter(function (c) { return !isValidCodeFormat(c); });
        } else {
          // Code NATIF : conserver l'opération active ET les autres natifs ; éviter son doublon.
          keep = existing.filter(function (c) { return c.toUpperCase() !== up; });
        }
        var newSet = keep.concat(up);
        return fetch(UPDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: newSet.join(','), sections: [] })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var itemCount = (data && data.item_count) || 0;
        var isOp = isValidCodeFormat(up);
        var found = (((data && data.discount_codes) || []).filter(function (d) {
          return d.code && d.code.toUpperCase() === up;
        })[0]);

        // ACCEPTATION :
        //  - OPÉRATION : optimiste. Présent dans la réponse OU panier vide (invalidable côté
        //    serveur -> s'appliquera dès l'ajout d'articles).
        //  - NATIF (ex. BIENVENUE10) : seulement si Shopify le confirme `applicable:true`.
        //    Shopify renvoie aussi les fautes de frappe (applicable:false) -> c'est le filtre.
        var accepted = isOp
          ? (!!found || itemCount === 0)
          : (!!found && found.applicable === true);

        // CONFLIT DE CUMUL : un AUTRE code déjà appliqué qui empêche celui-ci de passer.
        // Deux familles bloquent un code natif (= remise de COMMANDE) :
        //  - un autre code NATIF : deux remises « commande » ne se combinent que si les DEUX
        //    l'autorisent -> en pratique exclusives entre elles ;
        //  - une offre d'opération configurée SANS cumul avec les remises de commande : les
        //    offres de TYPE 2 (5 €/produit) le sont par construction, et certains codes
        //    dédiés le sont par réglage admin (NO_ORDER_CUMUL_CODES). Le cumul Shopify étant
        //    BILATÉRAL, elles rejettent le code natif.
        // Les opérations qui acceptent les remises de commande (grille de lots QIP05,
        // LIP10…) ne bloquent rien et ne doivent JAMAIS être accusées, sinon on enverrait le
        // client retirer un code parfaitement innocent.
        //
        // Corrigé le 2026-08-18 : le filtre excluait tous les codes d'opération, si bien que
        // le cas le plus fréquent en pratique — un QIP50 encore actif dans le panier (souvent
        // réappliqué tout seul par le cookie `discount_code` d'un ancien lien) — tombait dans
        // le message générique « Code invalide ou périmé » et envoyait chercher une faute de
        // frappe inexistante.
        var conflit = (((data && data.discount_codes) || []).filter(function (d) {
          var c = (d.code || '').toUpperCase();
          if (!d.applicable || c === up) return false;
          return !isValidCodeFormat(c) || isType2(c) || NO_ORDER_CUMUL_CODES.indexOf(c) !== -1 || !!presseOf(c);
        })[0]);

        if (!accepted) {
          // Option A : panier vide + code natif = non validable -> inviter à ajouter un article
          // plutôt que d'afficher à tort un code (potentiellement erroné) comme actif.
          if (!isOp && itemCount === 0) {
            showError(box, 'Ajoutez un article à votre panier pour activer ce code.');
          } else if (!isOp && conflit) {
            // Shopify renvoie `applicable:false` aussi bien pour une faute de frappe que pour un
            // refus de cumul : indiscernable sans re-soumettre le code seul (2 requêtes de plus
            // + panier à restaurer si l'une échoue). On privilégie le cas de loin le plus
            // fréquent — code correct + offre non cumulable déjà au panier — et on nomme le
            // coupable, avec le geste exact qui débloque la situation.
            // Formulation sans symbole : le « (✕) » renvoyait à la croix de la pastille,
            // peu lisible pour le public de la marque. On nomme le geste en toutes lettres.
            showError(box, 'Vous bénéficiez déjà du code « ' + conflit.code + ' ». '
              + 'Ces deux réductions ne se cumulent pas : retirez le code actif en cliquant '
              + 'sur la croix, puis saisissez à nouveau le code souhaité.');
          } else {
            showError(box, 'Code invalide ou périmé. Vérifiez la saisie.');
          }
          if (input) { input.value = ''; input.focus(); }
          done();
          return;
        }

        if (input) input.value = '';
        // Seul un code d'opération devient le currentCode (pilote cadeaux/plafond) ; un code
        // natif s'ajoute à l'affichage sans toucher l'opération active.
        if (isOp) { currentCode = up; storeCode(up); }
        updateCodeBlocks(displayList(data));
        // Prévenir les cartes de lots de se reconstruire sans rechargement.
        document.dispatchEvent(new CustomEvent('ma:code-applied', { bubbles: true }));
        if (data && data.item_count > 0) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        }
        applyDomRules();
        done();
      })
      .catch(function () {
        // Repli réseau : lien d'application natif (rechargement de page).
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname);
      });
    }
  }

  // ---------------------------------------------------------------------------
  // Retirer UN code (croix ✕ d'une pastille) — on ne retire que ce code, on garde les autres.
  // Sans argument (repli) : retire les codes d'OPÉRATION, conserve les codes natifs.
  // ---------------------------------------------------------------------------
  function removeCode(targetCode) {
    var target = (targetCode || '').toUpperCase();
    function clearUi() {
      currentCode = '';
      forgetCode();
      updateCodeBlocks([]);
      applyDomRules();
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        var applicable = (((cart && cart.discount_codes) || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; }));
        var next = target
          ? applicable.filter(function (c) { return c.toUpperCase() !== target; })
          : applicable.filter(function (c) { return !isValidCodeFormat(c); }); // repli : opérations
        return fetch(UPDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: next.join(','), sections: [] })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Si le code retiré était l'opération active (ou repli sans cible), on remet
        // l'état d'opération à zéro (cadeaux/plafond). Un code natif retiré n'y touche pas.
        if (!target || (isValidCodeFormat(target) && target === (currentCode || '').toUpperCase())) {
          currentCode = '';
          forgetCode();
        }
        updateCodeBlocks(displayList(data)); // reste : opération + natifs encore applicables
        applyDomRules();
        // Les cartes de lots se reconstruisent selon l'état d'opération courant.
        document.dispatchEvent(new CustomEvent('ma:code-applied', { bubbles: true }));
        if (data && data.item_count > 0) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        }
      })
      .catch(clearUi); // hors ligne : au moins nettoyer l'affichage
  }

  // Ouvre le tiroir panier Horizon (avec replis).
  function openCart() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { d.open(); return; }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trig) { trig.click(); return; }
    window.location.href = '/cart';
  }

  // ---------------------------------------------------------------------------
  // Délégation d'événements (survit au ré-rendu des sections)
  // ---------------------------------------------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ma-code-form]');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-ma-code]');
    var input = form.querySelector('[name="ma_code"]');
    applyCode(input ? input.value : '', box);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('[data-ma-code-remove]');
    if (rm) { e.preventDefault(); removeCode(rm.getAttribute('data-code') || ''); return; }
    if (e.target.closest('[data-ma-code-cart]')) { e.preventDefault(); openCart(); return; }
  });

  // Saisie/clic sur un compteur de quantité -> réactualiser l'état du bouton « + ».
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('.quantity-selector input[type="number"]')) applyQtyCap();
  });

  document.addEventListener('cart:update', refresh);
  document.addEventListener('ma:code-applied', refresh);
  window.addEventListener('storage', function (e) {
    if (e.key === 'ma_code_value' || e.key === 'ma_code_active') {
      currentCode = fromLocal();
      updateCodeBlocks(currentCode ? [currentCode] : []);
      scheduleFilter();
    }
  });

  // ---------------------------------------------------------------------------
  // AUTO-APPLICATION DEPUIS L'URL — `?ma_code=QIP50`
  // ---------------------------------------------------------------------------
  // Posé par les liens des emailings : le client clique, le code est saisi POUR lui.
  // Sans ça, `/discount/{CODE}` (cookie Shopify) donne bien la remise au paiement, mais
  // le thème n'en sait rien tant que le panier est vide -> la fiche produit continue
  // d'afficher le prix unitaire et réclame le code. Les liens des emails posent donc les
  // DEUX : /discount/... pour Shopify, ?ma_code=... pour l'affichage.
  //
  // Aucun contournement possible : on passe par le même applyCode() que la saisie manuelle,
  // donc par le même contrôle de format + liste blanche d'empreintes. Un code périmé
  // collé dans une URL est refusé exactement comme s'il était tapé.
  function applyCodeFromUrl() {
    var m = /[?&]ma_code=([^&#]*)/.exec(window.location.search || '');
    if (!m) return;

    // Le paramètre ne doit pas survivre : ni dans un lien re-partagé, ni dans l'historique,
    // ni dans les URL que les outils d'analyse enregistrent. On le retire tout de suite,
    // que le code soit finalement accepté ou non.
    var code = '';
    try { code = decodeURIComponent(m[1] || '').trim().toUpperCase(); } catch (e) { code = ''; }
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('ma_code');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}

    if (!code) return;
    if (code === fromLocal()) return; // déjà actif : inutile de refaire un aller-retour panier
    applyCode(code, document.querySelector('[data-ma-code]')); // box absente = toléré
  }

  function boot() {
    applyCodeFromUrl();
    refresh();
    // Le drawer panier est ré-injecté (section-rendering) -> ré-applique le filtre quand le DOM bouge.
    try {
      new MutationObserver(scheduleFilter).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
